import BoltIcon from '@mui/icons-material/Bolt';
import { Box, styled } from '@mui/material';
import { memo } from 'react';
import { FormattedMessage } from 'react-intl';

import { useBoolean } from '../../../hooks/useBoolean';
import { SquareButton } from '../../Button/SquareButton/SquareButton';
import { ResourcesAllocationPopin } from './ResourcesAllocationPopin';

const StyledPropagateButton = styled(SquareButton)`
    margin: auto;
    text-transform: uppercase;
    padding: 19px 20px;

    & .MuiButton-startIcon {
        margin-left: -10px;

        > :nth-of-type(1) {
            font-size: 24px;
        }
    }
`;

export const ResourcesAllocationButton = memo(function ResourcesAllocationButton({ disabled }: { disabled?: boolean }) {
    const { value: openedAllocate, setTrue: openAllocate, setFalse: closeAllocate } = useBoolean();

    return (
        <>
            <StyledPropagateButton
                color="secondary"
                size="small"
                variant="contained"
                onClick={openAllocate}
                startIcon={<BoltIcon />}
                disabled={disabled}
            >
                <Box mr={'-4px'}>
                    <FormattedMessage id="rms.allocation.automatic.button" />
                </Box>
            </StyledPropagateButton>
            {openedAllocate && <ResourcesAllocationPopin onClose={closeAllocate} />}
        </>
    );
});
